import "vant/es/toast/style/less";
import _Toast from "vant/es/toast";
import Queue from './queue';
var loadingCore = new Queue();
var DEFAULT_TIMEOUT = 5000;
var timer;
export default {
  show: function show(props) {
    var _props$timeout;

    var timeout = (_props$timeout = props === null || props === void 0 ? void 0 : props.timeout) !== null && _props$timeout !== void 0 ? _props$timeout : DEFAULT_TIMEOUT;
    loadingCore.show();

    _Toast.loading(props);

    if (timer) {
      clearTimeout(timer);
    }

    if (timeout && typeof timeout === 'number') {
      // 超时保护
      timer = setTimeout(function () {
        if (!loadingCore.isQueueEmpty) {
          loadingCore.clearQueue();

          _Toast.clear();
        }
      }, timeout);
    }
  },
  hide: function hide() {
    loadingCore.hide();

    if (loadingCore.isQueueEmpty) {
      _Toast.clear();
    }
  }
};